import { FormInput } from '@systemeio/ui'
import React from 'react'
import Option from '../Option'

type TextFieldProps = {
  value?: string
  update: (value: string) => void
  label: string
}

function TextField({ label, value = '', update }: TextFieldProps) {
  function setTextValue(event: React.ChangeEvent<HTMLInputElement>) {
    update(event.target.value)
  }

  return (
    <Option label={label}>
      <FormInput value={value} onChange={setTextValue} />
    </Option>
  )
}

export default TextField
